import useSelectedProductInformation from "../../modules/ProductView/useSelectedProductInformation";
import useProductSelectableOptions from "../../modules/ProductView/useProductSelectableOptions";
import useCallbackTriggerOnCondition from "theme/components/helpers/useCallbackTriggerOnCondition";

export const resolveSelectedOptions = (options, selectedOptions) => {
  if (!Array.isArray(selectedOptions)) {
    return selectedOptions;
  }
  const resolvedOptions = selectedOptions
    .map((selectedOption) => {
      const productOption = options?.find(
        ({ attribute, label }) =>
          attribute.id === selectedOption.optionId ||
          attribute.label === selectedOption.label ||
          label === selectedOption.label
      );
      if (productOption) {
        const productValue = productOption.values.find(
          (productOptionValue) =>
            productOptionValue.value === selectedOption.optionValue ||
            productOptionValue.label === selectedOption.value
        );
        if (productValue) {
          return {
            optionId: productOption.attribute.id,
            optionValue: productValue.value,
          };
        }
      }
      return null;
    })
    .filter(Boolean);
  const selectedOptionsIndex = {};
  resolvedOptions.forEach(({ optionId, optionValue }) => {
    selectedOptionsIndex[optionId] = optionValue;
  });
  return selectedOptionsIndex;
};

const useSelectedProductWithConfigurableOptions = (
  product,
  initialSelectedOptions
) => {
  const selectableOptions = useProductSelectableOptions(product);

  const {
    selectedProduct,
    selectedOptions,
    setOption,
    setSelectedOptions,
    baseProduct,
    selectedSku,
  } = useSelectedProductInformation(product, selectableOptions);

  useCallbackTriggerOnCondition(
    () => {
      setSelectedOptions(
        resolveSelectedOptions(product.options, initialSelectedOptions)
      );
    },
    product?.options && initialSelectedOptions, // call when this is truthy
    true, // if condition met on mount call callback
    true // call callback only once ever (whether on mount or not)
  );

  return {
    selectedProduct,
    selectedOptions,
    setOption,
    baseProduct,
    selectedSku,
  };
};

export default useSelectedProductWithConfigurableOptions;
